var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 11 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "5.22223", cy: "5", r: "5", fill: "#CCCCCC" },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M5.22025 2C5.39187 2 5.53708 2.06628 5.65589 2.19885C5.7747 2.32853 5.83411 2.48559 5.83411 2.67003C5.83411 2.85447 5.77338 3.01153 5.65193 3.14121C5.53312 3.27089 5.38923 3.33573 5.22025 3.33573C5.05127 3.33573 4.90738 3.27089 4.78857 3.14121C4.66975 3.01153 4.61035 2.85447 4.61035 2.67003C4.61035 2.48559 4.66975 2.32853 4.78857 2.19885C4.90738 2.06628 5.05127 2 5.22025 2ZM5.7747 3.95821V7.16138C5.7747 7.44669 5.80507 7.62968 5.86579 7.71037C5.92652 7.78818 6.04533 7.83285 6.22223 7.84438V8H4.22223V7.84438C4.38593 7.83862 4.50738 7.78674 4.58659 7.68876C4.63939 7.62248 4.66579 7.44669 4.66579 7.16138V4.80115C4.66579 4.51585 4.63543 4.33429 4.5747 4.25648C4.51398 4.17579 4.39649 4.12968 4.22223 4.11816V3.95821H5.7747Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }